import { connect } from 'react-redux';

import { WixConnect } from 'shared/utils/wix-connect';

import { BaseAccountButton } from './account-button';
import styles from './account-button-strip.styl';

@connect(state => ({
  appSettings: state.appSettings,
  currentSiteUser: state.currentSiteUser,
}))
@WixConnect(styles)
export default class AccountButtonStrip extends BaseAccountButton {
  static displayName = 'AccountButtonStrip';
}



// WEBPACK FOOTER //
// ./src/widget/components/account/account-button-strip.js